import { render, staticRenderFns } from "./_content_recomend.vue?vue&type=template&id=54e3be98&"
import script from "./_content_recomend.vue?vue&type=script&lang=js&"
export * from "./_content_recomend.vue?vue&type=script&lang=js&"
import style0 from "./_content_recomend.vue?vue&type=style&index=0&id=54e3be98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports